/**
 * LoadingState component - Skeleton loader for folders
 */

import React from 'react';

const LoadingState: React.FC = () => {
  return (
    <div className="folder-grid">
      {[1, 2, 3, 4].map((index) => (
        <div key={index} className="folder-card skeleton" aria-busy="true" aria-label="Loading folder">
          <div className="skeleton-icon"></div>
          <div className="skeleton-text">
            <div className="skeleton-title"></div>
            <div className="skeleton-count"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default LoadingState;

